import { FeatureFlag } from '@/features/standortContext/entities/featureFlag';

export class Standort {
  constructor({
    id,
    idStandortgruppe,
    name,
    abteilungenEnabled,
    isMonatAbgeschlossen,
    storeNummer,
    isTerminVerknuepfung,
    featureFlags,
    land,
  }: {
    id: string;
    idStandortgruppe: string;
    name: string;
    abteilungenEnabled?: boolean;
    isMonatAbgeschlossen?: boolean;
    storeNummer?: string;
    isTerminVerknuepfung?: boolean;
    featureFlags: FeatureFlag[];
    land: string;
  }) {
    this.id = id;
    this.idStandortgruppe = idStandortgruppe;
    this.name = name;
    this.abteilungenEnabled = abteilungenEnabled;
    this.isMonatAbgeschlossen = isMonatAbgeschlossen;
    this.storeNummer = storeNummer;
    this.isTerminVerknuepfung = isTerminVerknuepfung;
    this.featureFlags = featureFlags;
    this.land = land;
  }

  readonly id: string;
  readonly idStandortgruppe: string;
  readonly name: string;
  readonly storeNummer?: string;
  readonly abteilungenEnabled?: boolean;
  readonly isTerminVerknuepfung?: boolean;
  readonly isMonatAbgeschlossen?: boolean;
  readonly featureFlags: FeatureFlag[];
  readonly land: string;
}
